import React from 'react';
import Navigation from './Navigation';
import Particles from './Particles';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  fullscreen?: boolean;
  noBorders?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, title, subtitle, fullscreen = false, noBorders = false }) => {
  if (fullscreen) {
    return (
      <div className="min-h-screen bg-dark-900 flex flex-col">
        <Particles />
        <Navigation noBorder={true} />        <main className="flex-1 flex md:items-center justify-center overflow-y-auto">
          <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 pt-8 pb-20 md:py-12">
            {children}
          </div>
        </main>
        <Footer noBorder={true} absolute={true} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-900 overflow-x-hidden" style={{ isolation: 'isolate' }}>
      <Particles />
      <Navigation noBorder={noBorders} />

      <div className="">
        {title && (
          <div className={`pt-20 bg-dark-800/50 backdrop-blur-lg ${noBorders ? '' : 'border-b border-white/10'}`}>
            <div className="max-w-6xl px-4 py-16 mx-auto text-center sm:px-6 lg:px-8">
              <h1 className="mb-4 text-4xl font-bold text-white lg:text-5xl">
                {title}
              </h1>
              {subtitle && (
                <p className="max-w-3xl mx-auto text-xl text-white/80">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        )}

        <main className={`max-w-6xl px-4 mx-auto sm:px-6 lg:px-8 ${title ? 'py-12' : 'pt-24 pb-12'}`} style={{ transform: 'translate3d(0,0,0)', WebkitOverflowScrolling: 'touch' }}>
          {children}
        </main>
      </div>

      <Footer noBorder={noBorders} />
    </div>
  );
};

export default Layout;
